<template>
	<v-toolbar
		v-if="tagGroupTabs.length > 1"
		flat
		height="auto"
		extended
		density="compact"
		color="trueWhite"
		class="mb-3 mt-1"
	>
		<template #extension>
			<v-tabs
				v-model="currentTab"
				color="secondary"
				selected-class="tabs-slider"
			>
				<v-tab v-for="tab in tagGroupTabs" :key="tab.uuid" class="text-caption">
					{{ tab.name }}
				</v-tab>
			</v-tabs>
		</template>
	</v-toolbar>
	<v-tabs-window v-model="currentTab">
		<v-tabs-window-item v-if="tagGroupTabs.length === 0" :value="0">
			<slot name="tagGroupTab" :tab="null" :index="0" />
		</v-tabs-window-item>
		<v-tabs-window-item
			v-for="(tab, tabIndex) in tagGroupTabs"
			:key="tabIndex"
			:value="tabIndex"
		>
			<slot name="tagGroupTab" :tab="tab" :index="tabIndex" />
		</v-tabs-window-item>
	</v-tabs-window>
</template>

<script>
export default {
	name: "VMetadataTagGroupTabsBar",
	props: {
		tagGroupTabs: { type: Array, default: () => [] },
		currentTagGroupTab: { type: Number, required: true },
	},
	emits: ["update:current-tag-group-tab"],

	setup() {},

	data() {
		return {};
	},
	computed: {
		currentTab: {
			get() {
				return this.tagGroupTabs.length === 0 ? 0 : this.currentTagGroupTab;
			},
			set(val) {
				this.$emit("update:current-tag-group-tab", val);
			},
		},
	},

	methods: {},
};
</script>

<style lang="scss">
.metadata-toolbar-button {
	&.v-icon.v-icon::after {
		opacity: 0 !important;
	}
}
</style>
